import { MessageCircle } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const ShareResult = ({ game, result, path }) => {
  const { t } = useI18n();
  const text = `${t("share.text", { game, result })} ${window.location.origin}${path}`;
  return (
    <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid="share-result-whatsapp-btn"
      className="flex h-11 items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 text-sm font-semibold text-[#0B0D12] transition-transform active:scale-95">
      <MessageCircle className="h-4 w-4" /> {t("share.btn")}
    </a>
  );
};
